'use strict';
import { __values } from "tslib";
var angular = require('angular');
var dayjs = require('dayjs');
var CartService = /** @class */ (function () {
    function CartService($http, Util, $rootScope, $cookies, $q, Auth, CommonDataService, CredentialListService, $state, googleAnalytic, CartEvents) {
        'ngInject';
        this.errorCodes = {
            heatSensitive: 15,
            heatSensitiveFrozen: 112,
            manufacturerRestriction: 115 // Item {0} is restricted to the ship to address you provide due to shipping restrictions/ regulations from the manufacturer.
        };
        this.readyForPayment = false;
        this.readyForReviewOrder = false;
        this.hasItemLevelShippingIssue = false;
        this.activePromises = 0; // records state of how many active promises have yet to return
        this.cartSummaryData = null;
        this.restrictedItemIds = ' ';
        this.isItemRemoved = false;
        this.cartCallingFlag = 0;
        this.cartHasShippingRestrictions = false;
        this.failedOrderCart = null;
        this.itemLevelErrors = false;
        this.defaultWarehouseKey = 5; //TODO: Warehouse Service should get this
        this.user = null;
        this._$http = $http;
        this._$rootScope = $rootScope;
        this.$cookies = $cookies;
        this.handleSuccess = Util.handleSuccess;
        this.handleError = Util.handleError;
        this.flattenWarnings = Util.flattenWarnings;
        this.Auth = Auth;
        this.cvv = null;
        this.hidecvv = false;
        this.cartEmptyStatus = false;
        this._$q = $q;
        this._postRequest = CommonDataService;
        this.ccType = 0;
        this.expressCheckoutStatus = '';
        this.linkableStatus = '';
        this.CredentialListService = CredentialListService;
        this.$state = $state;
        this.expressCheckoutContext = {};
        this.cartId = null;
        this.cachedCartRequest = null;
        this.cartChangeCallbacks = [];
        this.GoogleAnalyticsService = googleAnalytic;
        this.CartEvents = CartEvents;
        this.updateCart();
    }
    CartService.prototype.getCartId = function () {
        return this.cartId;
    };
    CartService.prototype.setCartId = function (id) {
        this.cartId = id;
        this.cartChangeCallbacks.forEach(function (callback) { return callback(id); });
    };
    CartService.prototype.initializeCartId = function (id) {
        this.cartId = id;
    };
    CartService.prototype.overrideCSAPrice = function (param) {
        var xsrf_token = this.$cookies.get('XSRF-TOKEN');
        return this._$http({
            method: 'PUT',
            data: param,
            url: 'api/cart/overrideprice',
            headers: {
                'X-XSRF-TOKEN': xsrf_token
            },
            params: {
                cartId: this.cartId
            }
        });
    };
    CartService.prototype.getActivePromises = function () {
        return this.activePromises;
    };
    CartService.prototype.updateCart = function (isNewRequest) {
        var _this = this;
        this.Auth.isLoggedIn(function (isLoggedIn) {
            if (isLoggedIn) {
                _this.activePromises += 1;
                _this._getCart(isNewRequest)
                    .then(function (response) {
                    _this.cartCallingFlag = _this.cartCallingFlag + 1;
                    if (response.status != 200 && response.data && response.data.errors && response.data.errors.length) {
                        _this.handleError;
                    }
                    else {
                        _this.setNewCart(response.data.response);
                    }
                })
                    .finally(function () { return _this.activePromises -= 1; });
            }
        });
    };
    CartService.prototype.updateCartSummary = function () {
        var _this = this;
        this.Auth.isLoggedIn(function (isLoggedIn) {
            if (isLoggedIn) {
                _this.getCartSummary();
            }
        });
    };
    CartService.prototype.setNewCart = function (newCart) {
        if (newCart) {
            this.cartData = newCart;
        }
        if (newCart.aresLineItems) {
            this.cartData['quantityOfCartItems'] = newCart.aresLineItems
                .reduce(function (accum, item) {
                return accum + item.quantity;
            }, 0);
        }
        else {
            this.cartData.aresLineItems = [];
        }
        if (newCart.aresLineItems) {
            this.cartEmptyStatus = (newCart.aresLineItems.length > 0);
        }
        this.notifyCartRetrieved();
    };
    CartService.prototype.setNewCartSummary = function (newCartSummary) {
        if (newCartSummary) {
            this.cartSummaryData = newCartSummary;
        }
        this.notifyCartSummaryRetrieved();
    };
    CartService.prototype._getCart = function (isNewRequest) {
        var _this = this;
        if (!this.cachedCartRequest || isNewRequest) {
            this.activePromises += 1;
            this.cachedCartRequest = this._$http({
                method: 'get',
                url: 'api/cart',
                params: {
                    cartId: this.cartId
                }
            }).then(this.handleSuccess, this.handleError)
                .finally(function () { return _this.activePromises -= 1; });
        }
        return this.cachedCartRequest;
    };
    /**
     * Gets the current itemCount and subTotal of the cart.
     * Primarily for use with the cart icon.
     * @returns {*|Promise<R>|Promise<T>}
     */
    CartService.prototype.getCartSummary = function () {
        var _this = this;
        this.activePromises += 1;
        var request = this._$http({
            method: 'get',
            url: 'api/cart/summary',
            params: {
                cartId: this.cartId
            }
        });
        return (request
            .then(function (response) { return _this.setNewCartSummary(response.data.response); })
            .catch(this.handleError)
            .finally(function () { return _this.activePromises -= 1; }));
    };
    /*
       - Single add item
       - Multiple add item
       - Increase item quantity
       - Decrease item quantity
       - Remove item
     */
    /**
     * Responsible for returning the practitioners user details.
     * @returns a user
     */
    CartService.prototype.getUser = function () {
        if (!this.user) {
            this.user = this.Auth.getLoggedInUser();
        }
        return this.user;
    };
    /**
     * Responsible for returning an item obj for ecommerce tracking
     * @param item
     * @param quantity
     * @returns {{quantity, item_id, price: string}}
     */
    CartService.prototype.getItemObj = function (item, quantity) {
        return {
            item_id: item.itemId,
            price: (item.totalPrice / item.quantity).toFixed(2),
            quantity: quantity
        };
    };
    /**
     * Responsible for getting the list of items from the cart
     * @param items
     * @param cartResponse
     * @param quantity
     * @returns {*[]}
     */
    CartService.prototype.getItemList = function (items, cartResponse, quantity) {
        var _this = this;
        var itemsList = [];
        cartResponse.items.forEach(function (item) {
            if (items.indexOf(item.itemId) > -1) {
                itemsList.push(_this.getItemObj(item, quantity));
            }
        });
        return itemsList;
    };
    /**
     * Responsible for sending the cart event to GTM
     * @param event
     * @param user
     * @param items
     */
    CartService.prototype.sendCartEvent = function (event, user, items) {
        this.GoogleAnalyticsService.sendGTMEvent(event, {
            practitionerId: (user ? user.customerId : null),
            ecommerce: {
                items: items
            }
        });
    };
    /**
     * Responsible for sending tracking events based on line item addition actions.
     * @param items - a list of item ids
     * @param cartResponse - the response from calling POST on a cart to add items
     * @param quantity - the specified quantity of items added for single item additions
     */
    CartService.prototype.sendCartAddEvent = function (items, cartResponse, quantity) {
        if (quantity === void 0) { quantity = 1; }
        // quantity > 0 solves issue on /cart/checkout where you can submit the same quantity already in cart
        if (quantity > 0) {
            this.sendCartEvent(this.CartEvents.practitionerCartEvents.productAddToCart, this.getUser(), this.getItemList(items, cartResponse, quantity));
        }
    };
    /**
     * Responsible for sending tracking events based on cart line item quantity removal
     * @param items
     * @param cartResponse
     * @param quantity
     */
    CartService.prototype.sendCartQuantityRemoveEvent = function (items, cartResponse, quantity) {
        this.sendCartEvent(this.CartEvents.practitionerCartEvents.productRemoveFromCart, this.getUser(), this.getItemList(items, cartResponse, quantity));
    };
    /**
     * Responsible for sending tracking events based on cart line items being completely removed
     * @param items
     */
    CartService.prototype.sendCartItemRemovedEvent = function (items) {
        this.sendCartEvent(this.CartEvents.practitionerCartEvents.productRemoveFromCart, this.getUser(), items);
    };
    CartService.prototype.addItem = function (itemid) {
        var _this = this;
        this.activePromises += 1;
        var request = this._$http({
            method: 'POST',
            url: 'api/cart/' + itemid,
            params: {
                cartId: this.cartId
            }
        });
        return (request.then(function (request) {
            if (request.data.errors) {
                angular.forEach(request.data.errors, function (error) {
                    console.log(error.message);
                });
            }
            if (request.data.warnings) {
                angular.forEach(request.data.warnings, function (warning) {
                    console.log(warning.message);
                });
            }
            _this.sendCartAddEvent([itemid], request.data.response);
            _this.setNewCartSummary(request.data.response);
        }, this.handleError)
            .finally(function () { return _this.activePromises -= 1; }));
    };
    CartService.prototype.addItems = function (items) {
        var _this = this;
        this.activePromises += 1;
        var request = this._$http({
            method: 'POST',
            url: 'api/cart/list',
            data: {
                items: items
            },
            params: {
                cartId: this.cartId
            }
        });
        return (request.then(function (response) {
            if (response.data.errors) {
                angular.forEach(response.data.errors, function (error) {
                    console.log(error.message);
                });
            }
            if (response.data.warnings) {
                angular.forEach(response.data.warnings, function (warning) {
                    console.log(warning.message);
                });
            }
            _this.sendCartAddEvent(items, response.data.response);
            _this.setNewCartSummary(response.data.response);
            _this._getCart(true)
                .then(function (response) {
                _this.setNewCart(response.data.response);
            });
            //this.setNewCart(response.data.response);
            return response;
        }, this.handleError)
            .finally(function () { return _this.activePromises -= 1; }));
    };
    CartService.prototype.removedRestrictedProduct = function (cartProducts) {
        var self = this;
        var itemIds = '';
        var isCredStatus = false;
        var removedItem;
        var credentialList = this.CredentialListService.getCredentials();
        return (credentialList.then(function (response) {
            if (response.status == 200 && response.data) {
                var credentialList = response.data;
                for (var cred = 0; cred < credentialList.length; cred++) {
                    if (credentialList[cred].status != null && (credentialList[cred].status == "Approved" || credentialList[cred].status == "Pending Review")) {
                        isCredStatus = true;
                        break;
                    }
                }
                if (!isCredStatus && !self.itemLevelErrors) {
                    var itemRemoved = void 0;
                    if (cartProducts) {
                        for (var cp = 0; cp < cartProducts.length; cp++) {
                            if (cartProducts[cp].isRestricted) {
                                itemRemoved = self.removeItem(cartProducts[cp].itemId);
                                self.restrictedItemIds += cartProducts[cp].itemId + ',';
                            }
                        }
                        //Removed last ',' from restrictedItemIds.
                        if (self.restrictedItemIds.endsWith(",")) {
                            self.restrictedItemIds = self.restrictedItemIds.slice(0, -1);
                        }
                    }
                    if (itemRemoved) {
                        return (itemRemoved.then(function (response) {
                            return response;
                        }));
                    }
                }
            }
            return;
        }));
    };
    CartService.prototype.removeItem = function (itemid) {
        var _this = this;
        this.activePromises += 1;
        var request = this._$http({
            method: 'DELETE',
            url: 'api/cart/' + itemid,
            params: {
                cartId: this.cartId
            }
        });
        return (request.then(function (response) {
            // TODO: Display warning/error messages in banner
            if (response.status == 200 && response.data) {
                _this.isItemRemoved = true;
                _this.cartSummaryData.items.every(function (lineItem) {
                    if (lineItem.itemId === itemid) {
                        _this.sendCartItemRemovedEvent([_this.getItemObj(lineItem, lineItem.quantity)]);
                        return false;
                    }
                    return true;
                });
            }
            return _this._$q.all([
                _this.setNewCartSummary(response.data.response),
                _this._getCart(true)
            ])
                .then(function (responses) {
                _this.setNewCart(responses[1].data.response);
                return response;
            });
        })
            .catch(function (reason) {
            return _this._$q.reject(reason);
        })
            .finally(function () { return _this.activePromises -= 1; }));
    };
    CartService.prototype.removeItems = function (items) {
        var _this = this;
        this.activePromises += 1;
        var request = this._$http({
            method: 'POST',
            url: 'api/cart/deleteList',
            data: {
                items: items
            },
            params: {
                cartId: this.cartId
            }
        });
        return (request.then(function (response) {
            if (response.data.errors) {
                angular.forEach(response.data.errors, function (error) {
                    console.log(error.message);
                });
            }
            if (response.data.warnings) {
                angular.forEach(response.data.warnings, function (warning) {
                    console.log(warning.message);
                });
            }
            var trackingItems = [];
            items.forEach(function (itemId) {
                _this.cartSummaryData.items.every(function (lineItem) {
                    if (lineItem.itemId === itemId) {
                        trackingItems.push(_this.getItemObj(lineItem, lineItem.quantity));
                        return false;
                    }
                    return true;
                });
            });
            _this.sendCartItemRemovedEvent(trackingItems);
            _this.setNewCartSummary(response.data.response);
            _this._getCart(true)
                .then(function (response) {
                _this.setNewCart(response.data.response);
            });
            //this.setNewCart(response.data.response);
            return response.data.response;
        })
            .catch(function (reason) {
            return _this._$q.reject(reason);
        })
            .finally(function () { return _this.activePromises -= 1; }));
    };
    CartService.prototype.itemQuantity = function (itemid, quantity) {
        var _this = this;
        this.activePromises += 1;
        var self = this;
        var xsrf_token = this.$cookies.get('XSRF-TOKEN');
        var request = this._$http({
            method: 'PUT',
            headers: {
                'X-XSRF-TOKEN': xsrf_token
            },
            data: {
                quantity: quantity
            },
            url: 'api/cart/' + itemid,
            params: {
                cartId: this.cartId
            }
        });
        return (request.then(function (response) {
            if (response.data) {
                if (response.data.errors) {
                    angular.forEach(response.data.errors, function (error) {
                        console.log(error.message);
                    });
                }
                if (response.data.warnings) {
                    angular.forEach(response.data.warnings, function (warning) {
                        console.log(warning.message);
                    });
                }
                var isDecrease_1 = false;
                var quantityValue_1 = 0;
                // Look at the line items to determine if this is an increase or decrease.
                _this.cartSummaryData.items.every(function (lineItem) {
                    if (lineItem.itemId === itemid) {
                        isDecrease_1 = (lineItem.quantity > quantity);
                        quantityValue_1 = (isDecrease_1 ?
                            lineItem.quantity - quantity :
                            quantity - lineItem.quantity);
                        return false;
                    }
                    return true;
                });
                if (isDecrease_1) {
                    _this.sendCartQuantityRemoveEvent([itemid], response.data.response, quantityValue_1);
                }
                else {
                    _this.sendCartAddEvent([itemid], response.data.response, quantityValue_1);
                }
                _this.setNewCartSummary(response.data.response);
                return response.data;
            }
        }, this.handleError)
            .finally(function () { return _this.activePromises -= 1; }));
    };
    CartService.prototype.updateItemList = function (itemList) {
        var _this = this;
        this.activePromises += 1;
        var self = this;
        var xsrf_token = this.$cookies.get('XSRF-TOKEN');
        var request = this._$http({
            method: 'PUT',
            headers: {
                'X-XSRF-TOKEN': xsrf_token
            },
            data: itemList,
            url: 'api/cart/updateItemList',
            params: {
                cartId: this.cartId
            }
        });
        return (request.then(function (response) {
            if (response.data) {
                if (response.data.errors) {
                    angular.forEach(response.data.errors, function (error) {
                        console.log(error.message);
                    });
                }
                if (response.data.warnings) {
                    angular.forEach(response.data.warnings, function (warning) {
                        console.log(warning.message);
                    });
                }
                _this.setNewCartSummary(response.data.response);
                return response.data;
            }
        }, this.handleError)
            .finally(function () { return _this.activePromises -= 1; }));
    };
    CartService.prototype.addItemQuantity = function (itemId, quantity) {
        var _this = this;
        this.activePromises += 1;
        var self = this;
        var xsrf_token = this.$cookies.get('XSRF-TOKEN');
        var request = this._$http({
            method: 'POST',
            headers: {
                'X-XSRF-TOKEN': xsrf_token
            },
            data: {
                itemId: itemId,
                quantity: quantity
            },
            url: 'api/cart/',
            params: {
                cartId: this.cartId
            }
        });
        return (request.then(function (response) {
            if (response.data) {
                if (response.data.errors) {
                    console.log('response.data.errors add item', response.data.errors);
                    angular.forEach(response.data.errors, function (error) {
                        console.log(error.message);
                    });
                }
                if (response.data.warnings) {
                    console.log('response.data.warnings add item', response.data.warnings);
                    angular.forEach(response.data.warnings, function (warning) {
                        console.log(warning.message);
                    });
                }
                _this.sendCartAddEvent([itemId], response.data.response, quantity);
                _this.setNewCartSummary(response.data.response);
                //self.setNewCart(response.data.response);
                return response.data;
            }
            //TODO: Display warning/error messages in banner
        })
            .catch(function (reason) {
            return _this._$q.reject(reason);
        }) //this.handleError
            .finally(function () { return _this.activePromises -= 1; }));
    };
    CartService.prototype.addShippingAddress = function (selectedAddress, selectedAddressType, keepShippingOption) {
        var _this = this;
        this.Auth.clearAccountCache();
        if (selectedAddress.saveNewAddress) {
            delete selectedAddress.addressKey;
        }
        if (!selectedAddress.regionName) {
            selectedAddress.regionName = "";
        }
        if (!selectedAddress.regionCode) {
            selectedAddress.regionCode = "";
        }
        if (!selectedAddress.isDefault) {
            selectedAddress.isDefault = false;
        }
        if (!selectedAddress.postalCode) {
            selectedAddress.postalCode = "";
        }
        selectedAddress.keepShippingOption = !!keepShippingOption;
        // set these to defaults when not populated
        selectedAddress.addressType = !selectedAddress.addressType ? 1 : selectedAddress.addressType;
        selectedAddress.warehouseKey = !selectedAddress.warehouseKey ? this.defaultWarehouseKey : selectedAddress.warehouseKey;
        selectedAddress.addressKey = !selectedAddress.addressKey ? 0 : selectedAddress.addressKey;
        if (!selectedAddress.isDropShip) {
            selectedAddress.isDropShip = false;
            if (selectedAddress.saveNewAddress && selectedAddressType == 'Patient') {
                selectedAddress.isDropShip = true;
            }
        }
        var xsrf_token = this.$cookies.get('XSRF-TOKEN');
        var request = this._$http({
            method: 'POST',
            headers: {
                'X-XSRF-TOKEN': xsrf_token
            },
            url: 'api/cart/shippingaddress',
            data: selectedAddress,
            params: {
                cartId: this.cartId
            }
        });
        return (request.then(function (response) {
            _this.setNewCartSummary(response.data.response);
            _this.setNewCart(response.data.response);
            return response;
        }, this.handleError));
    };
    CartService.prototype.addShippingMethod = function (selectedShipMethod) {
        this.Auth.clearAccountCache();
        var request = this._$http({
            method: 'POST',
            url: 'api/cart/addshipvia',
            data: selectedShipMethod,
            params: {
                cartId: this.cartId
            }
        });
        return (request.then(function (response) {
            return response;
        }, this.handleError));
    };
    CartService.prototype.updateShippingMethod = function (address, shippingMethod) {
        return this.getDeliveryOptions(address).then(function (response) {
            var methodList = response.data.response;
            var newShippingMethod = {};
            methodList.forEach(function (method) {
                if (method.shipVia === shippingMethod.shipVia) {
                    newShippingMethod = method;
                }
            });
            return newShippingMethod;
        });
    };
    CartService.prototype.addPayment = function (selectedPayment, paymentMethodType, verificationCode, basketName) {
        var _this = this;
        this.Auth.clearAccountCache();
        selectedPayment.paymentMethodType = paymentMethodType; // 'CreditCard';
        if (basketName) {
            selectedPayment.basketName = basketName;
        }
        var request = this._$http({
            method: 'POST',
            url: 'api/cart/payment',
            data: selectedPayment,
            params: {
                cartId: this.cartId
            }
        });
        return (request.then(function (response) {
            if (!!response === false || response.data.errors.length > 0) {
                return _this._$q.reject(response);
            }
            else if (response.status === 200 && response.data) {
                _this.setNewCart(response.data.response);
            }
            return response;
        })
            .catch(function (response) {
            return _this._$q.reject(response);
        }));
    };
    CartService.prototype.addPromoCode = function (promoid) {
        var _this = this;
        var request = this._$http({
            method: 'POST',
            url: 'api/cart/promocode/' + promoid,
            params: {
                cartId: this.cartId
            }
        });
        return (request.then(function (response) {
            if (response.data.errors) {
                var errors = _this.flattenWarnings(response.data.errors);
            }
            if (response.data.warnings) {
                var warnings = _this.flattenWarnings(response.data.warnings);
            }
            //TODO: Display warning/error messages in banner
            if (!errors.length && !warnings.length) {
                _this.setNewCart(response.data.response);
            }
            return {
                cart: response.data.response,
                warnings: warnings,
                errors: errors,
                status: response.status,
                statusText: response.statusText
            };
        }, this.handleError));
    };
    CartService.prototype.removePromoCode = function (promoid) {
        var _this = this;
        var request = this._$http({
            method: 'DELETE',
            url: 'api/cart/promocode/' + promoid,
            params: {
                cartId: this.cartId
            }
        });
        return (request.then(function (response) {
            if (response.data.errors) {
                var errors = _this.flattenWarnings(response.data.errors);
            }
            if (response.data.warnings) {
                var warnings = _this.flattenWarnings(response.data.warnings);
            }
            ////TODO: Display warning/error messages in banner
            _this.setNewCart(response.data.response);
            return {
                cart: response.data.response,
                warnings: warnings,
                errors: errors,
                status: response.status,
                statusText: response.statusText
            };
        }, this.handleError));
    };
    CartService.prototype.updatePricing = function () {
        var _this = this;
        this._$rootScope.updatingPricing = true;
        return this._$http({
            method: 'POST',
            url: 'api/cart/updatePricing',
            params: {
                cartId: this.cartId
            }
        }).then(function (response) {
            return response.data;
        })
            .catch(function (response) {
            return _this._$q.reject(response);
        })
            .finally(function () {
            _this._$rootScope.updatingPricing = false;
        });
    };
    CartService.prototype.subscribe = function (scope, callback, isNewRequest) {
        var handler = this._$rootScope.$on('cart-retrieved', callback);
        scope.$on('$destroy', handler);
        this.updateCart(isNewRequest);
    };
    CartService.prototype.notifyCartRetrieved = function () {
        this._$rootScope.$emit('cart-retrieved', this.cartData);
        if (!this.cartSummaryData ||
            this.cartSummaryData.itemCount !== this.cartData.quantityOfCartItems ||
            this.cartSummaryData.subtotal !== this.cartData.subTotal) {
            this.getCartSummary();
        }
    };
    CartService.prototype.subscribeToSelectedCartChange = function (scope, callback) {
        var _this = this;
        this.cartChangeCallbacks.push(callback);
        scope.$on('$destroy', function () { return _this.cartChangeCallbacks = _this.cartChangeCallbacks.filter(function (value) { return value != callback; }); });
    };
    CartService.prototype.subscribeToCartSummary = function (scope, callback) {
        var handler = this._$rootScope.$on('cart-summary-retrieved', callback);
        scope.$on('$destroy', handler);
        this.updateCartSummary();
    };
    CartService.prototype.notifyCartSummaryRetrieved = function () {
        this._$rootScope.$emit('cart-summary-retrieved', this.cartSummaryData);
    };
    CartService.prototype.getShipingOptions = function () {
        var request = this._$http({
            method: 'GET',
            url: 'api/cart/shippingoptions',
            params: {
                cartId: this.cartId
            }
        });
        return request;
    };
    CartService.prototype.addShippingVia = function (shippingOption) {
        var request = this._$http({
            method: 'POST',
            url: 'api/cart/addshipvia',
            data: shippingOption,
            params: {
                cartId: this.cartId
            }
        });
        return (request.then(function (response) {
            return response;
        }, this.handleError));
    };
    CartService.prototype.getDeliveryOptions = function (address) {
        var addressParams = angular.copy(address);
        addressParams.cartId = this.cartId;
        // shipping option api accept address as parameter
        var request = this._$http({
            method: 'GET',
            url: 'api/cart/shippingoptions',
            params: addressParams
        });
        return (request.then(function (response) {
            return response;
        }, this.handleError));
    };
    CartService.prototype.getShipViaLabel = function (shipVia) {
        var carrier;
        shipVia = shipVia || '';
        if (shipVia.indexOf('Economy') === 0) {
            carrier = "SurePost";
        }
        else if (shipVia.indexOf("Priority Mail") === 0 || shipVia.indexOf("Express Mail") === 0) {
            carrier = "USPS";
        }
        else {
            shipVia = shipVia.replace('UPS', '');
            carrier = "UPS";
        }
        if (carrier) {
            return carrier + " " + shipVia;
        }
        else {
            return shipVia;
        }
    };
    CartService.prototype.processOrder = function (order, selfVal, failedOrderCart) {
        if (failedOrderCart) {
            this.failedOrderCart = failedOrderCart;
        }
        var url = 'api/cart/order' + (this.cartId ? "?cartId=" + this.cartId : '');
        return this._postRequest.postRequest(url, order, selfVal)
            .then(function (response) {
            return response;
        });
    };
    CartService.prototype.resetFailedOrderCart = function () {
        this.failedOrderCart = null;
    };
    CartService.prototype.setExpressCheckoutStatus = function (status) {
        this.expressCheckoutStatus = status;
    };
    CartService.prototype.getExpressCheckoutStatus = function () {
        return this.expressCheckoutStatus;
    };
    CartService.prototype.setNewDeliveryMethod = function (val) {
        this.Auth.clearAccountCache();
        var self = this;
        this.getDeliveryOptions(val.selectedAddress)
            .then(function (shippingMethodsResponse) {
            if (shippingMethodsResponse.status === 200) {
                val.defaultShipMethod = self.decideShipMethod(shippingMethodsResponse.data.response, val.defaultShipViaName);
                val.deliveryDate = val.defaultShipMethod.latestDeliveryDate;
            }
            else {
                val.$log.debug(shippingMethodsResponse.status);
            }
        });
    };
    CartService.prototype.getDeliveryDate = function (shippingMethodId) {
        return this.getShipingOptions().then(function (response) {
            var shippingMethodList = response.data.response;
            var deliveryDate = '';
            shippingMethodList.forEach(function (shippingMethod) {
                if (shippingMethod.shippingMethodId === shippingMethodId ||
                    (shippingMethodId === 'Standard' && shippingMethod.shippingMethodId.indexOf('Standard') > -1)) {
                    deliveryDate = shippingMethod.latestDeliveryDate;
                }
            });
            return deliveryDate;
        });
    };
    CartService.prototype.updateDeliveryOption = function () {
        var _this = this;
        this._getCart(true).then(function (response) {
            var cart = response.data.response;
            if (cart.shipVia) {
                var methodId = cart.shipVia.shippingMethodId;
                _this.getDeliveryDate(methodId).then(function (deliveryDate) {
                    _this._$rootScope.$emit('update-delivery-date', deliveryDate);
                });
            }
        });
    };
    CartService.prototype.displayDate = function (str) {
        // convert date string to date value as local date
        var datetime = dayjs(str);
        var days = str.split('-')[2];
        var dateString = datetime.format('ddd, MMM D');
        if (days[0] === '1') {
            // 10 to 19 add th
            dateString += 'th';
        }
        else {
            // add post-fix with last digit
            switch (days[1]) {
                case '1':
                    dateString += 'st';
                    break;
                case '2':
                    dateString += 'nd';
                    break;
                case '3':
                    dateString += 'rd';
                    break;
                default:
                    dateString += 'th';
            }
        }
        return dateString;
    };
    CartService.prototype.decideShipMethod = function (shippingOptingList, defaultShipViaName, isPatientAddress) {
        var possibleDefaultIds = [
            'Standard',
            isPatientAddress ? 'Standard 3 Day' : 'Standard 2 Day',
            isPatientAddress ? 'FX 3Day Air' : 'FX 2Day Air',
            'Priority Mail',
            'WW Standard'
        ];
        return shippingOptingList.find(function (shippingOption) { return possibleDefaultIds.indexOf(shippingOption.shippingMethodId) > -1; });
    };
    CartService.prototype.goExpressCheckout = function (val) {
        var _this = this;
        var selectedPayment = {};
        this.expressCheckoutContext = {
            shippingAddress: val.selectedAddress,
            shipVia: val.defaultShipMethod,
            payment: val.selectedPayment
        };
        //checking the presence of selected card and then assigning the cardType
        if (val.selectedPayment) {
            this.ccType = val.selectedPayment.cardType;
        }
        if ((val.selectedPayment) && (val.selectedPayment.paymentType === 'Terms' ||
            val.selectedPayment.paymentType === 'COD' ||
            val.selectedPayment.paymentType === 'Prepaid')) {
            this.addShippingAddress(val.selectedAddress)
                .then(function (response) {
                _this.checkForShippingWarnings(response);
                _this.checkForShippingErrors(response);
            })
                .then(function () { return _this.addShippingMethod(val.defaultShipMethod); })
                .then(function () { return _this.setExpressCheckoutStatus(true); })
                .then(function () {
                _this.addPayment(selectedPayment, val.selectedPayment.paymentType, null)
                    .then(function () {
                    _this.hideCVV(true);
                    _this.updatePricing();
                    if (!_this.cartHasShippingRestrictions) {
                        val.$state.go(val.decideWhereToGo(), { referrer: 'expressCheckout' });
                    }
                });
            })
                //.then(() => val.$state.go(val.decideWhereToGo(), {referrer : 'expressCheckout'}))
                .catch(function (error) { throw error; });
        }
        else {
            this.addShippingAddress(val.selectedAddress)
                .then(function (response) {
                _this.checkForShippingWarnings(response);
                _this.checkForShippingErrors(response);
            })
                .then(function () { return _this.addShippingMethod(val.defaultShipMethod).then(function () {
                _this.hideCVV(false);
            }); })
                .then(function () { return _this.setExpressCheckoutStatus(true); })
                .then(function () { return _this.updatePricing(); })
                .then(function () {
                if (!_this.cartHasShippingRestrictions) {
                    val.$state.go(val.decideWhereToGo(), { referrer: 'expressCheckout' });
                }
            })
                .catch(function (error) { throw error; });
        }
    };
    CartService.prototype.checkForShippingWarnings = function (response) {
        if (response && response.data.warnings && response.data.warnings.length) {
            var shippingWarnings = response.data.warnings.filter(function (item) {
                return (item.code == '115' || item.code == '875' || item.code == '876');
            });
            if (shippingWarnings.length) {
                this.cartHasShippingRestrictions = true;
                this.$state.go('shippingAndDelivery');
            }
        }
    };
    CartService.prototype.checkForShippingErrors = function (response) {
        if (response && response.data.errors && response.data.errors.length) {
            var shippingErrors = response.data.errors.filter(function (item) {
                return (item.code == '118');
            });
            if (shippingErrors.length) {
                this.cartHasShippingRestrictions = true;
                this.$state.go('shippingAndDelivery');
            }
        }
    };
    CartService.prototype.setLinkStatus = function (status) {
        this.linkableStatus = status;
    };
    CartService.prototype.getLinkStatus = function () {
        return this.linkableStatus;
    };
    CartService.prototype.getCartEmptyStatus = function () {
        return this.cartEmptyStatus;
    };
    CartService.prototype.setCVV = function (cvv) {
        this.cvv = cvv;
    };
    CartService.prototype.getCVV = function () { return this.cvv; };
    CartService.prototype.hideCVV = function (bool) {
        this.hidecvv = !!bool;
    };
    CartService.prototype.ifHideCVV = function () {
        return this.hidecvv;
    };
    /**
     * Finds and returns the cart item from the provided list of items
     * @param {String} itemId
     * @param {Array} lineItems
     * @returns {Object}
     */
    CartService.prototype.getItemFromCart = function (itemCode, lineItems) {
        if (lineItems && lineItems.length) {
            if (lineItems.length < 2) {
                return lineItems[0];
            }
            else {
                return lineItems.find(function (item) {
                    return item.itemCode === itemCode;
                });
            }
        }
    };
    CartService.prototype.getDefaultInventory = function (inventory) {
        var e_1, _a;
        try {
            for (var inventory_1 = __values(inventory), inventory_1_1 = inventory_1.next(); !inventory_1_1.done; inventory_1_1 = inventory_1.next()) {
                var item = inventory_1_1.value;
                if (item.isDefault) {
                    return item;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (inventory_1_1 && !inventory_1_1.done && (_a = inventory_1.return)) _a.call(inventory_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    CartService.prototype.setOrderResult = function (result) {
        this.orderResult = result;
        if (this.cartData && this.cartData.aresLineItems) {
            this.orderResult.salesOrder = this.cartData;
            this.orderResult.salesOrder['quantityOfCartItems'] = this.cartData.aresLineItems
                .reduce(function (accum, item) {
                return accum + item.quantity;
            }, 0);
        }
        else {
            this.orderResult.salesOrder.aresLineItems = [];
        }
    };
    CartService.prototype.getOrderResult = function () { return this.orderResult; };
    CartService.prototype.hasItemLevelShippingProblem = function () {
        var _this = this;
        var check = false;
        var cart = this.cartData;
        cart.aresLineItems.forEach(function (item) {
            item.warnings.forEach(function (warning) {
                if (warning && _this.itemLevelShippingChecks(warning.code)) {
                    check = true;
                }
            });
            item.errors.forEach(function (error) {
                if (error && _this.itemLevelShippingChecks(error.code)) {
                    check = true;
                }
            });
        });
        return check;
    };
    CartService.prototype.itemLevelShippingChecks = function (code) {
        return (code === this.errorCodes.heatSensitive ||
            code === this.errorCodes.heatSensitiveFrozen ||
            code === this.errorCodes.manufacturerRestriction);
    };
    CartService.prototype.findItem = function (id, cart) {
        if (!cart) {
            cart = this.cartData;
        }
        var found = cart.aresLineItems.find(function (item) {
            return item.itemId === id;
        });
        return found;
    };
    CartService.prototype.submitAkrisOrder = function (akrisOrder) {
        return this._$http.post('api/cart/akrisOrder', akrisOrder);
    };
    CartService.prototype.getAllCarts = function (storeFront) {
        if (!storeFront)
            return;
        var request = this._$http({
            method: 'get',
            url: "api/cart/getAllCarts",
            params: {
                storefrontId: storeFront
            }
        });
        return (request
            .then(function (response) { return response; })
            .catch(this.handleError));
    };
    CartService.prototype.createInactiveCart = function (storeFront) {
        var _this = this;
        var request = this._$http({
            method: 'post',
            data: JSON.stringify({ storefrontId: storeFront }),
            url: "api/cart/createCart"
        });
        return (request
            .then(function (response) {
            _this.setCartId(parseInt(response.data.body));
            return response;
        })
            .catch(this.handleError));
    };
    CartService.prototype.deleteInactiveCart = function (storeFront) {
        var _this = this;
        if (!storeFront)
            return;
        var request = this._$http({
            method: 'DELETE',
            url: "api/cart/deleteCart",
            params: {
                storefrontId: storeFront,
                cartId: this.cartId
            }
        });
        return (request
            .then(function (response) {
            _this.setCartId(null);
            return response;
        })
            .catch(this.handleError));
    };
    return CartService;
}());
export default CartService;
//# sourceMappingURL=cart.service.js.map